var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"hide-details":"","outlined":"","dense":"","items":_vm.items,"label":_vm.$t('message.paid_with'),"item-text":"name","item-value":"value"},on:{"input":event => { _vm.emitChange(event) }},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }